<template>
  <div
    v-if="fields"
    no-gutters
    class="py-5 content-section-wrapper"
    :class="[backgroundClass, textClass]"
  >
    <div class="content-center">
      <div class="content-constraint">
        <v-row justify="center" align="center">
          <v-col
            cols="12"
            :sm="fields.alignment ? 6 : 12"
            :order="fields.alignment === AligmentEnum.LEFT ? 2 : 1"
            :style="{ 'text-align': !fields.alignment && !$vuetify.breakpoint.xs ? 'center' : '' }"
          >
            <h2 v-if="fields.heading">{{ fields.heading }}</h2>
            <p v-if="fields.subHeading">{{ fields.subHeading }}</p>
            <ctf-rich-text
              v-if="fields.description"
              :document="fields.description"
            />
          </v-col>
          <v-col
            cols="12"
            :sm="fields.alignment ? 6 : 12"
            :order="fields.alignment === AligmentEnum.LEFT ? 1 : 2"
          >
            <v-row no-gutters justify="center">
              <v-col
                cols="12"
                :sm="fields.alignment ? 12 : 8"
                :md="fields.alignment ? 12 : 6"
                :xl="fields.alignment ? 12 : 4"
              >
                <video v-if="fields.embedMedia" width="100%" controls>
                  <source :src="assetURL" />
                </video>
                <div v-else class="embed-container">
                  <iframe
                    :title="fields.heading + ' Media asset'"
                    :src="url"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </div>
                <div
                  v-if="fields.transcript"
                  class="sr-only"
                  title="Video Transcript"
                >
                  {{ fields.transcript }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getCTFAsset } from '@/plugins/contentful'
import { sanitizeVideoLink, backgroundColorClass, textColorClass } from '@/utils/helpers'

const AligmentEnum = Object.freeze({
  LEFT: 'left',
  RIGHT: 'right'
})

/** Two options for video from contentful:
 * a url to Youtube/Vimeo (this.fields.embedLink), or an actual video file sent in the assets. (this.fields.embedMedia)
 * If both options are sent from Contentful then the video file will be the one shown.
 */
export default {
  name: 'StandaloneVideo',
  props: {
    fields: {
      type: Object,
      default: null
    },
    assets: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      assetURL: '',
      AligmentEnum
    }
  },
  computed: {
    url () {
      return sanitizeVideoLink(this.fields.embedLink)
    },
    backgroundClass () {
      return backgroundColorClass(this.fields.backgroundColor)
    },
    textClass () {
      return textColorClass(this.fields.backgroundColor)
    }
  },
  created () {
    if (this.fields.embedMedia) {
      // They are sending their own video file instead of a link to youtube/vimeo, must find in assets
      const video = getCTFAsset(
        this.fields.embedMedia.sys.id,
        this.assets
      )
      this.assetURL = video.fields.file.url
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/variables";

.content-section-wrapper {
  background-color: $light-gray;
  width: 100%;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  width: 100%;
  overflow: hidden;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
